import type { FC, PropsWithChildren } from "react";
import { StyledBasicLabel } from "./styles";

const SignalBasicLabel: FC<PropsWithChildren> = ({ children }) => {
    return <StyledBasicLabel>{children}</StyledBasicLabel>;
};

export default SignalBasicLabel;
